import { Branch, GetListResponse } from "./portalCompany.type";
import { IRole } from "./user.type";
import { LogAction as LogActionConst } from "@/constants/Log.constants";

export interface ILog {
  id: string | number;
  action: LogAction;
  email: string;
  status: LogStatus;
  name: string;
  role: IRole;
  companyId: string | number;
  company?: GetListResponse;
  branchId: string | number;
  branch?: Branch;
  date: string;
  time: string;
}

export interface ILogFilters {
  action?: LogAction;
  email?: string;
  status?: LogStatus;
  company_id?: number | string;
  branch_id?: number | string;
  date?: string;
}

export enum LogStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE"
}

export enum LogAction {
  CREATE_COMPANY = "CREATE_COMPANY",
  GET_COMPANY = "GET_COMPANY",
  EDIT_COMPANY = "EDIT_COMPANY",
  LOGIN = "LOGIN",
  TOKEN_DECODE = "TOKEN_DECODE",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  SET_PASSWORD = "SET_PASSWORD",
  CREATE_USER = "CREATE_USER",
  UPDATE_USER = "UPDATE_USER"
}

// {
//   "id": 13430,
//   "action": "CHANGE_DATES",
//   "notes": "Change project Custom1 dates start date from 2025-04-07 to 2025-04-07 and end date from 2025-04-10 to 2025-05-06",
//   "date": "05/30/2025",
//   "time": "08:32 AM",
//   "object_data": {
//     "project_id": 1848,
//     "project_name": "Custom1",
//     "start_date": "2025-04-07",
//     "end_date": "2025-05-06",
//     "by_user_id": 1810
//   },
//   "email": "yzaporozhchenko@fido.tech"
// },

export type RecentActivity = {
  id: number;
  action: (typeof LogActionConst)[keyof typeof LogActionConst];
  notes: string;
  date: string;
  time: string;
  object_data: {
    project_id?: string | number;
    project_name?: string;
    partner_id?: string | number;
    partner_name?: string;
    company_id?: string | number;
    company_name?: string;
    session_id?: string;
    start_date?: string;
    end_date?: string;
    user_id?: string;
    user_name?: string;
    user_email?: string;
    by_user_id?: string | number;
    by_email?: string;
    dma_keys?: string[];
    dma_ids?: string | number[];
  };
  email: string;
};
